import { isIOSWebview } from '@/src/general/utils/isIOSWebview'

export const getNotificationsAvailable = () => !isIOSWebview() && 'Notification' in window && 'PushManager' in window
